import { render } from "./AuthorizedLayout.vue?vue&type=template&id=e2c69c1c"
import script from "./AuthorizedLayout.vue?vue&type=script&lang=js"
export * from "./AuthorizedLayout.vue?vue&type=script&lang=js"

import "./AuthorizedLayout.vue?vue&type=style&index=0&id=e2c69c1c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__